import LogRocket from 'logrocket';

import Config from '../core/Config';
import { SingleDirectorUserFragment } from '../generated/graphql';

interface LogRocket {
  identify: (userId: string, userData: Record<string, unknown>) => void;
  clearUserCookie: () => void;
}

export class LogRocketService {
  logRocket: typeof LogRocket;

  constructor(logRocket: typeof LogRocket, appVersion: string) {
    const config: Config = (window as any).__hugotconfig__;

    logRocket.init(config.LOGROCKET_APP_ID, { release: appVersion });
    logRocket.getSessionURL((sessionUrl: string) => {
      window.recordingUrl = sessionUrl;
      window.newrelic.setCustomAttribute('logrocket_url', sessionUrl);
    });
    this.logRocket = logRocket;
  }

  public identify(user: SingleDirectorUserFragment) {
    this.logRocket.identify(user.id, {
      displayName: user.name,
      email: user.email!,
    });

    return;
  }

  public anonymize() {
    this.logRocket.identify('Anonymous');
  }
}
